import { useQuery } from '@tanstack/react-query';
import { useResidentSession } from '@/components/Auth/useResidentSession';
import { getResidentLanguagePreference } from 'src/service/engageFrontendGateway';

export const MOCK_LANGUAGE_PREFERENCE_KEY = 'mock-resident-language-preference';

function readMockLanguagePreference(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(MOCK_LANGUAGE_PREFERENCE_KEY);
  } catch {
    return null;
  }
}

interface Args {
  region: string;
}

export function useResidentLanguagePreference({ region }: Args): {
  preferredLanguage: string | null;
  isLoading: boolean;
} {
  const { isAuthenticated, isSessionLoading, isMock } = useResidentSession();
  const shouldFetch = isAuthenticated && !isMock && !isSessionLoading;

  const { data, isLoading: isQueryLoading } = useQuery({
    queryKey: ['resident', 'language-preference', region],
    queryFn: () => getResidentLanguagePreference(region),
    enabled: shouldFetch,
    staleTime: 5 * 60 * 1000,
  });

  if (isMock) {
    return { preferredLanguage: readMockLanguagePreference(), isLoading: false };
  }
  return { preferredLanguage: data?.language ?? null, isLoading: shouldFetch && isQueryLoading };
}
